"use client"

import { SquareLibrary } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareLibraryIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareLibraryIcon = component(Icon)({ as: SquareLibrary })
